import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { style: {"height":"100%"} }
const _hoisted_2 = { style: {"width":"0","position":"absolute","top":"0","left":"0","bottom":"0","display":"flex","flex-direction":"column","overflow":"visible","z-index":"9"} }
const _hoisted_3 = { style: {"display":"flex","flex-direction":"column","position":"relative","height":"100%","overflow":"hidden"} }
const _hoisted_4 = { class: "initials ptr hvr-bg" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"500","overflow":"hidden","text-overflow":"ellipsis","text-wrap":"nowrap","color":"var(--focus-black-color)"} }, " Het Tarkhala's XDoc ", -1)
const _hoisted_6 = { style: {"display":"flex","flex-direction":"column","padding-bottom":"8px"} }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "button-icon" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, " Settings and members ", -1)
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "button-icon" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, " New page ", -1)
const _hoisted_13 = {
  class: "xdoc-scroller vertical",
  style: {"padding-top":"6px","padding-bottom":"20px","overflow":"hidden auto"}
}
const _hoisted_14 = { style: {"margin":"0px"} }
const _hoisted_15 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_16 = {
  role: "graphics-symbol",
  viewBox: "0 0 14 14",
  class: "plusThick",
  style: {"width":"14px","height":"14px","display":"block","fill":"rgba(55, 53, 47, 0.45)","flex-shrink":"0"}
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("path", { d: "M2 7.16357C2 7.59692 2.36011 7.95093 2.78735 7.95093H6.37622V11.5398C6.37622 11.9731 6.73022 12.3271 7.16357 12.3271C7.59692 12.3271 7.95093 11.9731 7.95093 11.5398V7.95093H11.5398C11.9731 7.95093 12.3271 7.59692 12.3271 7.16357C12.3271 6.73022 11.9731 6.37622 11.5398 6.37622H7.95093V2.78735C7.95093 2.36011 7.59692 2 7.16357 2C6.73022 2 6.37622 2.36011 6.37622 2.78735V6.37622H2.78735C2.36011 6.37622 2 6.73022 2 7.16357Z" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"auto"} }, null, -1)
const _hoisted_20 = { style: {"position":"absolute","right":"0","top":"0","height":"100%","width":"8px","cursor":"col-resize"} }

import { ref, computed, onBeforeMount } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useMenuLeftStore } from "../../stores/menuLeft";
import MenuPageNavigationSpaceView from "./MenuPageNavigationSpaceView.vue";
import BaseButton from "./BaseButton.vue";
import { useRecordValuesStore } from "@/stores/recordValues";
import { getSpaces } from "@/services/api/getSpaces";
import { transformToStandardUUIDFormat } from "../helpers/router/transformToStandardUUIDFormat";
import uuid from "@/helpers/globals/uuid";
import { useGeneralStore } from "@/stores/general";
import { makeOperation } from "@/services/transactions/factories/makeOperation";
import { makeTransaction } from "@/services/transactions/factories/makeTransaction";
import { useTransactionsQueue } from "@/stores/transactionsQueue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuLeft',
  props: {
    spaceId: {
        type: String,
        required: true
    },
    spaceViewId: {
        type: String,
        required: true
    }
},
  setup(__props) {

const route = useRoute();
const router = useRouter();

const menuLeftStore = useMenuLeftStore();
const recordValuesStore = useRecordValuesStore();

const props = __props

let favoritesPagesIds = ref([]), privatePagesIds = ref([]);

const getMenuMode = computed(function () {
    return menuLeftStore.menuLeftMode;
})

async function createNewPage() {

    const rawId = uuid();
    const id = transformToStandardUUIDFormat(rawId);

    const pointer = {
        id,
        table: "block",
        spaceId: props.spaceId
    };

    const operations = [
        makeOperation(
            "set",
            {
                id,
                type: 'page',
                space_id: props.spaceId
            },
            [],
            pointer
        ),
        
        makeOperation(
            "update",
            {
                permissions: [{
                    type: "user_permission",
                    role: "editor",
                    user_id: "user_id"  
                }]
            },
            [],
            pointer
        ),

        makeOperation(
            "update",
            {
                parent_id: props.spaceId,
                parent_table: "space",
                alive: true
            },
            [],
            pointer
        ),

        makeOperation(
            "listBefore",
            {
                id
            },
            ["private_pages"],
            {
                id: props.spaceViewId,
                table: "space_view",
                spaceId: props.spaceId
            }
        ),

        makeOperation(
            "update",
            {
                created_by_id: "user_id",
                created_by_table: "xdoc_user",
                created_time: Date.now(),
                last_edited_by_id: "user_id",
                last_edited_by_table: "xdoc_user",
                last_edited_time: Date.now()
            },
            [],
            pointer
        )
    ]

    useTransactionsQueue().enqueue(
        makeTransaction({
            debug: {
                userAction: "MenuLeft.createNewPage"
            },
            spaceId: props.spaceId,
            operations
        })
    );


    if (route.name === "render-page") {
        router.push({ query: { p: rawId, pm: 'c' } });
    }
    else {
        router.push(`/${rawId}`);
    }
}

//hides left menu
function setMenuLeftMode() {
    menuLeftStore.setMenuLeftMode(null);
}

const generalStore = useGeneralStore();

function openSettings() {
    console.log('add logic to open settings');
    generalStore.setCurrentComponentInDefaultOverlay(
        "space_settings",
        {}
    )
}

onBeforeMount(async () => {
  try{
    const userSpaces = await getSpaces();

    const spaceViews = userSpaces.data.space_view;
  
    for(const id in spaceViews) {
      const { spaceId, value: { value } } = spaceViews[id];
  
      recordValuesStore.setRecordValue({
        id,
        table: "space_view",
        record: value,
        spaceId
      });
    }

    const { bookmarked_pages, private_pages } = recordValuesStore.getRecordValue({
        id: props.spaceViewId,
        table: "space_view",
        spaceId: props.spaceId
    });

    privatePagesIds.value = private_pages;
    favoritesPagesIds.value = bookmarked_pages;
  } catch(e) {
    console.log(e);
  }
})

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("nav", {
    id: "menu-left",
    class: _normalizeClass(getMenuMode.value !== 'full' ? 'translate-menu-left' : ''),
    style: {"z-index":"111"}
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          id: "menu-left-wrapper",
          class: _normalizeClass(getMenuMode.value !== 'full' ? 'translate-menu-left-wrapper' : '')
        }, [
          _createElementVNode("div", {
            style: _normalizeStyle([getMenuMode.value !== 'full' ? 'display: block;' : 'display: none;', {"position":"absolute","height":"100%","inset":"0"}])
          }, null, 4),
          _createElementVNode("div", {
            style: _normalizeStyle([getMenuMode.value !== 'full' ? 'display: block;' : 'display: none;', {"position":"absolute","height":"100%","inset":"0","background-color":"white"}])
          }, null, 4),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_font_awesome_icon, { icon: ['far', 'user'] }),
              _hoisted_5,
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'angles-left'],
                class: "icon hvr-bg ptr",
                id: "close-menu",
                onClick: _withModifiers(setMenuLeftMode, ["prevent","stop"])
              }, null, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: "button-wrapper hvr-bg ptr",
                onClick: _withModifiers(openSettings, ["prevent","stop"])
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fas', 'gear'],
                    class: "icon"
                  })
                ]),
                _hoisted_9
              ], 8, _hoisted_7),
              _createElementVNode("div", {
                class: "button-wrapper hvr-bg ptr",
                onClick: _withModifiers(createNewPage, ["prevent","stop"])
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fas', 'circle-plus'],
                    class: "icon"
                  })
                ]),
                _hoisted_12
              ], 8, _hoisted_10)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(MenuPageNavigationSpaceView, { pageIds: _unref(favoritesPagesIds) }, {
                  header: _withCtx(() => [
                    _createTextVNode("Favorites")
                  ]),
                  _: 1
                }, 8, ["pageIds"]),
                _createVNode(MenuPageNavigationSpaceView, { pageIds: _unref(privatePagesIds) }, {
                  header: _withCtx(() => [
                    _createTextVNode("Private")
                  ]),
                  "navigation-options": _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(BaseButton, {
                        onClick: _withModifiers(createNewPage, ["stop"]),
                        style: {"height":"20px","width":"20px","display":"flex","align-items":"center","margin-left":"4px"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock("svg", _hoisted_16, _hoisted_18))
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  _: 1
                }, 8, ["pageIds"])
              ])
            ]),
            _hoisted_19
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_20, null, 512), [
            [_vShow, getMenuMode.value === 'full']
          ])
        ], 2)
      ])
    ])
  ], 2))
}
}

})